import { lenis, gsap } from '../global/gsap';

const initMenu = (toggle, header) => {
    const body = document.querySelector('.js-body');
    const navSecondary = document.querySelector('.js-nav-secondary');
    const contactTrigger = document.querySelector('.js-contact-toggle');
    const locationTriggers = document.querySelectorAll('.js-nav-contact-trigger');
    const stopScrollingClass = 'stop-scrolling';
    const isActiveClass = 'menu-open';
    const contactActiveClass = 'contact-open';
    let isActive = false;

    toggle.addEventListener('click', (e) => {
        e.preventDefault();
        isActive = !isActive;

        if (isActive) {
            lenis.stop();
            body.classList.add(stopScrollingClass, isActiveClass);

            // Clear the pinned header and stop it reacting to scroll while open.
            if (header) header.lock();
        } else {
            lenis.start();
            body.classList.remove(stopScrollingClass, isActiveClass, contactActiveClass);

            // Wait for the scroll-restore jump to settle before re-enabling the
            // header, so it isn't re-pinned on close. It then resumes responding
            // to genuine scroll up/down.
            if (header) {
                requestAnimationFrame(() => requestAnimationFrame(() => header.unlock()));
            }
        }
    });

    if (contactTrigger) {
        contactTrigger.addEventListener('click', (event) => {
            event.preventDefault();
            body.classList.toggle('contact-open');
            navSecondary.scrollTop = 0;
        });
    }

    if (locationTriggers && locationTriggers.length > 0) {
        locationTriggers.forEach((trigger) => {
            let locationActive = false;
            const content = trigger.nextElementSibling;

            trigger.addEventListener('click', () => {
                locationActive = !locationActive;

                trigger.parentNode.classList.toggle('is-active');

                gsap.to(content, {
                    height: locationActive ? 'auto' : '0'
                });
            });
        });
    }
};

export { initMenu as default };
